import { render, staticRenderFns } from "./directionButtons.vue?vue&type=template&id=57145663&scoped=true&"
import script from "./directionButtons.vue?vue&type=script&lang=js&"
export * from "./directionButtons.vue?vue&type=script&lang=js&"
import style0 from "./directionButtons.vue?vue&type=style&index=0&id=57145663&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57145663",
  null
  
)

export default component.exports